@if (culturalActivityTypeMetadata; as typeMetadata) {
    <div class="activity-card card"
         [class.is-completed]="activity.isCompleted"
         [class.is-overdue]="isOverdue && highlightOverdue"
         [class.is-upcoming]="!isOverdue"
         [style.--activity-accent]="typeMetadata.colourAccent">
        <div class="card-body d-flex flex-column gap-3">
            <div class="d-flex flex-row gap-2 align-items-center">
                <h4 class="m-0 flex-grow-1">
                    @if (activity.type === CulturalActivityType.PeerCatchUp || activity.type === CulturalActivityType.TeamAssessment) {
                        @if (activity.team) {
                            <a [routerLink]="routeLink?.path"
                               [queryParams]="routeLink?.queryParams">{{ activity.team.name }}</a>:
                        } @else if (activity.teamId) {
                            @if (activity.teamId) {
                                <adapt-link-team [teamId]="activity.teamId"></adapt-link-team>
                            }
                            :
                        }
                    }
                    @if (activity.type === CulturalActivityType.CareerValuation || activity.type === CulturalActivityType.CulturalIndex) {
                        @if (currentPersonWithoutCulturalLeader) {
                            {{ typeMetadata.shortTitle }} for yourself
                        } @else {
                            @if (currentPersonIsCulturalLeaderForActivity) {
                                {{ typeMetadata.shortTitle }} for
                            } @else {
                                {{ isCulturalLeader ? "My " : "" }}{{ typeMetadata.shortTitle }} with
                            }
                            <adapt-link-person [personId]="otherPersonId ?? activity.person1Id"></adapt-link-person>
                        }
                    } @else if (activity.type === CulturalActivityType.PeerCatchUp) {
                        {{ typeMetadata.shortTitle }} with
                        <adapt-link-person [personId]="otherPersonId ?? activity.person1Id"></adapt-link-person>
                    } @else if (activity.extensions.isSurvey) {
                        {{ survey?.name ?? "Assessment to be scheduled" }}
                    }
                </h4>
                @if ((activity.type === CulturalActivityType.CareerValuation || activity.type === CulturalActivityType.CulturalIndex) && currentPersonIsCulturalLeaderForActivity && culturalLeadershipConfiguration) {
                    <i adaptTooltip="This {{ typeMetadata.shortTitle.toLocaleLowerCase() }} is as their {{ culturalLeadershipConfiguration.primaryName.toLocaleLowerCase() }}"
                       class="fal fa-chart-user"></i>
                }
                @if (menuItems && allowActions) {
                    <adapt-menu [items]="menuItems"></adapt-menu>
                }
            </div>
            <div class="d-flex flex-row gap-3 justify-content-between align-items-center">
                <div>
                    <!-- unsubscribeOnDestroy in case entitySync for culturalActivity causes the card to be destroyed -->
                    @if (canReschedule && allowActions) {
                        <button class="btn btn-link"
                                [adaptBlockingClick]="rescheduleActivity"
                                [unsubscribeOnDestroy]="false"
                                data-test="reschedule-activity-button">Reschedule</button>
                    }
                    <div class="text-muted">
                        {{ dueText }}: {{ dueDate | adaptDate }}
                        @if (hasRescheduled && !activity.isCompleted) {
                            <adapt-activity-rescheduled-info [activity]="activity"
                                                             [showOriginalDate]="!isStartedSurvey"></adapt-activity-rescheduled-info>
                        }
                    </div>
                </div>
                <div>
                    @if (canStartActivity && allowActions) {
                        <button class="btn btn-sm btn-primary"
                                [adaptButtonIcon]="startActivityIconClass"
                                [adaptBlockingClick]="startActivity"
                                [unsubscribeOnDestroy]="false"
                                data-test="activity-start-button">
                            {{ startActivityText }}
                        </button>
                    }
                </div>
            </div>
        </div>
    </div>
}
